import { apiGetOne } from './ApiBaseActions';
export const API_GET_ONE_CATEGORY = 'API_GET_ONE_CATEGORY';
export const API_GET_ONE_CATEGORY_SUCCESS = 'API_GET_ONE_CATEGORY_SUCCESS';
export const API_GET_ONE_CATEGORY_SELECT = 'API_GET_ONE_CATEGORY_SELECT';
export const API_GET_ONE_CATEGORY_SELECT_SUCCESS = 'API_GET_ONE_CATEGORY_SELECT_SUCCESS';
export const apiGetCategory = (meta) => apiGetOne(API_GET_ONE_CATEGORY, '/category', meta || {});
export const apiGetCategorySelect = (select, meta) => apiGetOne(API_GET_ONE_CATEGORY_SELECT, `/category/${select}`, Object.assign({}, meta));
